/**
 * Congolese franc.
 */
export var CDF = {
  code: 'CDF',
  base: 10,
  exponent: 2
};